import React from "react";
import {
  Row,
  Col,
  Button,
  Select,
  Space,
  Divider,
  Spin,
} from "antd";
import cx from "classnames";
import moment from "moment";
import { DoubleRightOutlined } from "@ant-design/icons";
import { ReactComponent as Cash } from "../assets/icons/cash.svg";
import { ReactComponent as Card } from "../assets/icons/card.svg";
import { ReactComponent as Driver } from "../assets/icons/driver.svg";
import { ReactComponent as PeyaCourierLogo } from "../assets/logo/pedidos-ya-courrier.svg";
import styles from "./styles/OrderActionsSection.module.css";
import { useEffect } from "react";
const { Option } = Select;

const OrderActionsSection = ({
  isCash,
  cashback,
  change,
  total,
  monitor,
  isAdmin,
  status,
  loading,
  selectBranch,
  handleSelectedBranch,
  confirmTransfer,
  branches,
  isDriver,
  orderType,
  peyaOrder,
  order,
  drivers,
  selectDriver,
  handleSelectedDriver,
  assingMonitorOrder,
  assing,
  id_driver,
  sendPeya,
  peyaConfirmCode,
  peyaStatus,
  peyaResult,
  spanish_peya,
  confirmCancel,
  confirmAcceptOrder,
  confirmUpdateOrder,
  confirmFinishOrder,
  deleting,
  sending,
}) => {

  const isValidDriver = drivers.some(
    (item) =>
      item.available === 1 &&
      item.withActiveOrder === 0 &&
      item.id !== id_driver?.id &&
      item.id === selectDriver
  );

  const safeSelectDriver = isValidDriver ? selectDriver : undefined;


  return (
    <Col xs={24} lg={12}>
      {/* FORMA DE PAGO */}
      <Row>
        <Col xs={24}>
          <div className={styles.paymentWrap}>
            <span className={styles.labelSection}>FORMA DE PAGO</span>
            {isCash ? (
              <div className={styles.methodWrap}>
                <div className={styles.method}>
                  <Cash className={styles.methodIcon} /> Pago en efectivo
                </div>
                <span className={styles.cashback}>
                  {`A entregar: $${parseFloat(cashback).toFixed(2)} Cambio: $${parseFloat(change).toFixed(2)}`}
                </span>
              </div>
            ) : (
              <div className={styles.methodWrap}>
                <div className={styles.method}>
                  <Card className={styles.methodIcon} /> Pago en tarjeta
                </div>
                <span className={styles.cashback}>
                  {`Valor: $${parseFloat(total).toFixed(2)}`}
                </span>
              </div>
            )}
          </div>
        </Col>
      </Row>

      {/* TRANSFERIR ORDEN */}
      {monitor && Boolean(isAdmin) && status < 11 && (
        <Row>
          <Col xs={24}>
            <div className={styles.selectDriverWrap}>
              <span className={styles.labelSection}>TRANSFERIR ORDEN</span>
              <Row gutter={20}>
                <Col xs={15} lg={17}>
                  <Select
                    className={styles.selectDriver}
                    loading={loading}
                    disabled={loading}
                    showSearch
                    size="large"
                    placeholder="Seleccionar Tienda"
                    optionFilterProp="children"
                    value={selectBranch}
                    onChange={handleSelectedBranch}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {branches.map((branch) => (
                      <Option key={branch.id} value={branch.id}>
                        {branch.zone}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col xs={9} lg={7}>
                  <Button
                    disabled={loading}
                    onClick={confirmTransfer}
                    loading={loading}
                    size="large"
                    type="primary"
                    className={styles.driverAssign}
                  >
                    TRANSFERIR
                  </Button>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      )}


      {/* DRIVER ASIGNADO */}
      {!isDriver && orderType == "2" && !peyaOrder && status >= 8 && (
        <Row>
          <Col xs={24}>
            <div className={styles.driverWrap}>
              <span className={styles.labelSection} style={{ marginTop: 20 }}>DRIVER ASIGNADO</span>
              <div className={styles.methodWrap}>
                <div className={styles.method}>
                  <Driver className={styles.methodIcon} />
                  <span className={cx(styles.green, styles.driverName)}>
                    {order.id_driver ? `${order.id_driver.name}` : "-"}
                  </span>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      )}

      {/* ASIGNAR DRIVER */}
      {monitor && !isDriver && orderType == "2" && !peyaOrder && status >= 7 && status < 11 && (
        <>
          {!isCash && (
            <Row>
              <Col xs={24}>
                <div className={styles.selectDriverWrap}>
                  <span className={styles.labelSection} style={{ marginTop: 20 }}>ASIGNAR DRIVER</span>
                  <Button
                    icon={<PeyaCourierLogo className={styles.peyaIconText} />}
                    onClick={sendPeya}
                    size="large"
                  >
                    <Space align="center">
                      Enviar <DoubleRightOutlined />
                    </Space>
                  </Button>
                </div>
                <Divider> o </Divider>
              </Col>
            </Row>
          )}

          <Row>
            <Col xs={24}>
              <div className={styles.selectDriverWrap}>
                {isCash && <span className={styles.labelSection} style={{ marginTop: 20 }}>ASIGNAR DRIVER</span>}
                <Row gutter={20}>
                  <Col xs={15} lg={17}>
                    <Select
                      className={styles.selectDriver}
                      loading={loading}
                      disabled={loading}
                      showSearch
                      size="large"
                      placeholder="Seleccionar Driver"
                      optionFilterProp="children"
                      value={safeSelectDriver}
                      onChange={handleSelectedDriver}
                      filterOption={(input, option) =>
                        option.children.toLowerCase().includes(input.toLowerCase())
                      }
                    >
                      {drivers
                        .filter((item) => item.available == 1)
                        .map((driver) => (
                          <Option key={driver.id} value={driver.id}>
                            {`${driver.name} ${driver.lastname}`}
                          </Option>
                        ))}
                    </Select>
                  </Col>
                  <Col xs={9} lg={7}>
                    <Button
                      disabled={loading}
                      onClick={assingMonitorOrder}
                      loading={assing}
                      size="large"
                      type="primary"
                      className={styles.driverAssign}
                    >
                      ASIGNAR PEDIDO
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </>
      )}

      {/* PEDIDOS YA INFO */}
      {(monitor || !monitor) && peyaOrder && (
        <Row>
          <Col xs={24}>
            <div className={styles.driverWrap}>
              <span className={styles.labelSection}>Asignado a Pedidos Ya Courier</span>
              <p>No. Confirmación: {peyaConfirmCode}</p>
              <p>
                Estado del Pedido: <strong>{spanish_peya[peyaStatus]}</strong>
              </p>
              <p>
                Tiempo de recogida: <strong>{moment(peyaResult.route.estimatedPickUpTime).format("DD/MM/YYYY HH:mm:ss")}</strong>
              </p>
              <p>
                Tiempo estimado: <strong>{moment(peyaResult.route.deliveryTimeTo).format("DD/MM/YYYY HH:mm:ss")}</strong>
              </p>
              <p>
                Distancia : <strong>{peyaResult.route.distance} (m)</strong>
              </p>
              {monitor && (
                <Space className={styles.submitWrap} size="middle" align="center" wrap={false}>
                  <Button
                    size="large"
                    type="primary"
                    danger
                    loading={deleting}
                    className={cx(styles.accept, styles.reject)}
                    onClick={confirmCancel}
                  >
                    CANCELAR PEDIDO
                  </Button>
                  <Button
                    loading={sending}
                    onClick={confirmFinishOrder}
                    size="large"
                    type="primary"
                    className={cx(styles.accept)}
                  >
                    ORDEN ENTREGADA
                  </Button>
                </Space>
              )}
            </div>
          </Col>
        </Row>
      )}

      {/* BOTONES DE ACCIÓN (sin Pedidos Ya) */}
      {monitor && !peyaOrder && (
        <Row>
          <Col xs={24}>
            <Space className={styles.submitWrap} size="middle" align="center" wrap={false}>
              {status >= 7 && status < 12 && (
                <Button
                  size="large"
                  type="primary"
                  danger
                  loading={deleting}
                  className={cx(styles.accept, styles.reject)}
                  onClick={confirmCancel}
                >
                  CANCELAR PEDIDO
                </Button>
              )}
              {status === 6 && (
                <Button
                  loading={sending}
                  size="large"
                  type="primary"
                  className={styles.accept}
                  onClick={confirmAcceptOrder}
                >
                  ORDEN EN PREPARACIÓN
                </Button>
              )}
              {status >= 7 && status < 11 && (
                <Button
                  loading={sending}
                  size="large"
                  type="primary"
                  className={styles.accept}
                  onClick={confirmUpdateOrder}
                >
                  {orderType == "1" ? "ORDEN LISTA" : "DESPACHAR ORDEN"}
                </Button>
              )}
              {status >= 10 && status < 12 && (
                <Button
                  loading={sending}
                  onClick={confirmFinishOrder}
                  size="large"
                  type="primary"
                  className={styles.accept}
                >
                  ORDEN ENTREGADA
                </Button>
              )}
              {isCash && status === 14 && (
                <Button
                  loading={sending}
                  onClick={confirmUpdateOrder}
                  size="large"
                  type="primary"
                  className={styles.accept}
                >
                  ORDEN EFECTIVO RECIBIDO
                </Button>
              )}
            </Space>
          </Col>
        </Row>
      )}
    </Col>
  );
};

export default OrderActionsSection;